// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_49400","header":"edae5","spinner":"cbc18"};